import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useI18n } from "@/context/I18nContext";

export const PLACE_LANGS = ["es", "fr", "ar", "hmn"];
const PREFIX = /^\/(es|fr|ar|hmn)(?=\/)/;
const placeLangOf = (lang) => (PLACE_LANGS.includes(lang) ? lang : null);

// Keeps /{lang}/nc/* and /nc/* in sync with the chosen language.
export const usePlaceLang = () => {
  const { lang, setLang } = useI18n();
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const urlLang = pathname.match(PREFIX)?.[1] || null;
  const first = useRef(true);
  const prevLang = useRef(lang);

  useEffect(() => {
    const changed = !first.current && prevLang.current !== lang;
    first.current = false;
    prevLang.current = lang;
    if (urlLang && lang !== urlLang) {
      if (changed) {
        const pl = placeLangOf(lang);
        navigate((pl ? `/${pl}` : "") + pathname.replace(PREFIX, "") + search, { replace: true });
      } else setLang(urlLang);
    } else if (!urlLang && placeLangOf(lang)) {
      navigate(`/${lang}${pathname}${search}`, { replace: true });
    }
  }, [lang, urlLang, pathname, search, navigate, setLang]);

  const pl = urlLang || placeLangOf(lang);
  const ready = urlLang ? lang === urlLang : !placeLangOf(lang);
  return { lang: pl || lang, base: pl ? `/${pl}/nc` : "/nc", isEs: urlLang === "es", ready };
};

export const altLinks = (site, path) => [
  { hrefLang: "en", href: `${site}/nc${path}` },
  ...PLACE_LANGS.map((l) => ({ hrefLang: l, href: `${site}/${l}/nc${path}` })),
  { hrefLang: "x-default", href: `${site}/nc${path}` },
];

export const usePlaceBase = () => {
  const { lang } = useI18n();
  const { pathname } = useLocation();
  const pl = pathname.match(PREFIX)?.[1] || placeLangOf(lang);
  return pl ? `/${pl}/nc` : "/nc";
};
